<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Nurturing</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#authors-note">Author’s Note</a></li>
<li id="toc-li-6"><a href="#/text/ch006#preface">Preface</a></li>
<li id="toc-li-7"><a href="#/text/ch007#part-1-nurture-yourself">Part 1: Nurture Yourself</a><ol class="toc"><li id="toc-li-8"><span href="#/text/Section0004#chapter-1-spirit-and-soul" title="Link target outside of Sample">Chapter 1 Spirit and Soul</span>
</li>
<li id="toc-li-15"><span href="#/text/Section0005#chapter-2-mind" title="Link target outside of Sample">Chapter 2 Mind</span>
</li>
<li id="toc-li-19"><span href="#/text/Section0006#chapter-3-body" title="Link target outside of Sample">Chapter 3 Body</span>
</li>
</ol></li>
<li id="toc-li-23"><span href="#/text/ch008#part-2-benefit-the-world" title="Link target outside of Sample">Part 2: Benefit the World</span><ol class="toc"><li id="toc-li-24"><span href="#/text/Section0007#chapter-4-why" title="Link target outside of Sample">Chapter 4 Why</span>
</li>
<li id="toc-li-26"><span href="#/text/Section0008#chapter-5-how" title="Link target outside of Sample">Chapter 5 How</span>
</li>
<li id="toc-li-31"><span href="#/text/Section0009#chapter-6-what" title="Link target outside of Sample">Chapter 6 What</span>
</li>
</ol></li>
<li id="toc-li-42"><span href="#/text/ch009#epilogue" title="Link target outside of Sample">Epilogue</span></li>
<li id="toc-li-43"><span href="#/text/ch010#notes" title="Link target outside of Sample">Notes</span></li>
<li id="toc-li-52"><span href="#/text/ch012#appendix-1-list-of-activities-that-nurture-our-spirit-soul-mind-and-body" title="Link target outside of Sample">Appendix 1: List of Activities That Nurture Our Spirit, Soul, Mind and Body</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?362389ac